<template>
    <sa-page-layout :btnRefreshVisible="true" @refresh="onRefresh" :showModalLoading="showModalLoading">
        <template #table-filter>
            <div class="sa-list-component-header" style="padding-top: 5px">
                <div class="sa-page-search-component">
                    <b-form style="width: 100%" @submit.prevent="onSubmit">
                        <b-row class="sa-form-btn-filter">
                            <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                                <label class="sa-label-data">Nome letto</label>
                                <div class="sa-page-search-component-wrapper" style="flex: 1; min-width: 70px">
                                    <input class="sa-page-search-component-input" v-model="filtroStoricoPostiLetto.nomeLetto" placeholder="Inserisci nome letto.." />
                                </div>
                                <button class="sa-page-search-component-btn-search" title="Search">
                                    <i class="fas fa-search"></i>
                                </button>
                                <button class="sa-page-search-component-btn-reset" @click="resetFiltroStoricoPostiLetto" type="button"><i class="fas fa-trash"></i></button>
                            </b-col>
                        </b-row>
                    </b-form>
                </div>
            </div>
        </template>
        <template slot="table-body">
            <rsa-storico-posto-letto-list-component ref="RsaStoricoPostoLettoListComponent" @afterLoadData="onAfterLoadData" @beforeLoadData="onBeforeLoadData"></rsa-storico-posto-letto-list-component>
        </template>
    </sa-page-layout>
</template>
<script>
import SaPageLayout from "../../../../template/sa/components/layout/contents/SaPageLayout.vue";
import RsaStoricoPostoLettoListComponent from "../components/RsaStoricoPostoLettoListComponent.vue";

export default {
    components: { SaPageLayout, RsaStoricoPostoLettoListComponent },

    data() {
        return {
            pathResource: "/rsapostilettoaccettazione",
            showModalLoading: false,
            filtroStoricoPostiLetto: {
                nomeLetto: null,
            },
        };
    },
    mounted() {
        let sessionStorage = window.sessionStorage;
        let filtroStoricoPostiLetto = sessionStorage.getItem("filtroStoricoPostiLetto");
        if (filtroStoricoPostiLetto) {
            this.filtroStoricoPostiLetto = JSON.parse(filtroStoricoPostiLetto);
        }
        this.showModalLoading = true;
    },
    methods: {
        onRefresh() {
            this.showModalLoading = true;
            this.$refs.RsaStoricoPostoLettoListComponent.loadData();
        },
        resetFiltroStoricoPostiLetto() {
            this.filtroStoricoPostiLetto = {
                nomeLetto: null,
            };
            let sessionStorage = window.sessionStorage;
            sessionStorage.setItem("filtroStoricoPostiLetto", JSON.stringify(this.filtroStoricoPostiLetto));
            this.onRefresh();
        },
        onAfterLoadData() {
            this.showModalLoading = false;
        },
        onBeforeLoadData() {
            this.showModalLoading = true;
        },
        onSubmit() {
            this.showModalLoading = true;
            let sessionStorage = window.sessionStorage;
            sessionStorage.setItem("filtroStoricoPostiLetto", JSON.stringify(this.filtroStoricoPostiLetto));
            this.$refs.RsaStoricoPostoLettoListComponent.loadData();
        },
    },
};
</script>
